import axios from "axios";
import { 
    ENDPOINT_CHARGING, 
    ENDPOINT_CHARGING_UPDATE,
    ENDPOINT_CHARGING_TRANSACTION_TYPES,
    ENDPOINT_CHARGING_RANGES_ADD,
    ENDPOINT_CHARGING_RANGES_DELETE,
    ENDPOINT_CHARGING_CALCULATE
} from "../../constants";
import { ApiResponse } from "../types";
import { handleApiError } from "../../utils/error_handler";
import { ChargingConfiguration, TransactionType, TransactionTypeCharging, ChargingRange, ChargeCalculation } from "./data";

// Retrieve charging configuration
export async function retrieveChargingConfiguration(): Promise<ChargingConfiguration> {
    try {
        const res = await axios.get<ApiResponse<ChargingConfiguration>>(ENDPOINT_CHARGING);
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as ChargingConfiguration;
    } catch (error: any) {
        throw handleApiError(error);
    }
}

// Update charging configuration for a transaction type
export async function updateChargingConfiguration(data: TransactionTypeCharging): Promise<void> {
    try {
        const res = await axios.post<ApiResponse<void>>(ENDPOINT_CHARGING_UPDATE, data);
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
    } catch (error: any) {
        throw handleApiError(error);
    }
}

// Get available transaction types
export async function getTransactionTypes(): Promise<TransactionType[]> {
    try {
        const res = await axios.get<ApiResponse<{ transactionTypes: TransactionType[] }>>(ENDPOINT_CHARGING_TRANSACTION_TYPES);
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return (res.data.Msg as any).transactionTypes;
    } catch (error: any) {
        throw handleApiError(error);
    }
}

// Add a new charging range
export async function addChargingRange(transactionType: string, subType: string, range: ChargingRange): Promise<void> {
    try {
        const res = await axios.post<ApiResponse<void>>(ENDPOINT_CHARGING_RANGES_ADD, {
            transactionType,
            subType,
            range
        });
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
    } catch (error: any) {
        throw handleApiError(error);
    }
}

// Delete a charging range
export async function deleteChargingRange(transactionType: string, subType: string, rangeId: string): Promise<void> {
    try {
        const res = await axios.post<ApiResponse<void>>(ENDPOINT_CHARGING_RANGES_DELETE, {
            transactionType,
            subType,
            rangeId
        });
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
    } catch (error: any) {
        throw handleApiError(error);
    }
}

// Calculate charge for an amount
export async function calculateCharge(transactionType: string, subType: string, amount: number): Promise<ChargeCalculation> {
    try {
        const res = await axios.post<ApiResponse<ChargeCalculation>>(ENDPOINT_CHARGING_CALCULATE, {
            transactionType,
            subType,
            amount
        });
        if (res.data.Code !== '200') {
            throw handleApiError({ response: { data: res.data } });
        }
        return res.data.Msg as ChargeCalculation;
    } catch (error: any) {
        throw handleApiError(error);
    }
}